export class Extraccion {
    [key: string]: string | number | undefined
    public clientId: number | undefined;
    public fallow: number | undefined;
    public rows: number | undefined;
    public type: string | undefined = 'first';
    public fallowPriority: string | undefined = 'date';
}